/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import React from 'react'
import styles from '../../components/Components.module.css'
import 'semantic-ui-css/semantic.min.css';
import Footer from '../Common/Footer'
import ResponsiveContainer from "../Common/ResponsiveContainer";
import {Grid, Header, List} from "semantic-ui-react";
import Rij from "../Common/Rij";
import {Link} from "react-router-dom";

const Eindredactie = () => (
    <ResponsiveContainer>
        <Grid container centered stackable>
            <Rij header={'Eindredactie'}>
                <Header as={'h1'} style={{fontSize: '3.6em'}}>Eindredactie</Header>
                <p className={styles.rijP} style={{marginTop: '4em'}}>

                    Lezers hebben over het algemeen weinig geduld.
                    Is de eerste alinea van een stuk oninteressant, staat er een onbegrijpelijke zin in,
                    of wordt er een toon gehanteerd die irriteert, dan is het vaak al einde oefening.
                    De lezer heeft alweer verder gebladerd in de krant, de brief weggelegd,
                    of de website weggeklikt. <br/><br/>
                    Deze les leerde ik tijdens mijn master Tekst en Communicatie aan de UvA.
                    En die bleek waar toen ik in de journalistiek aan de slag ging.
                    Als journalist leerde ik op welke plekken in mijn tekst lezers afhaken,
                    bijvoorbeeld door feedback te krijgen van chefs en eindredacteuren, en door
                    leesstatistieken in te zien. En inmiddels is het mijn werk om die afhaakmomenten
                    in de teksten van anderen te voorkomen. Zo werk ik sinds 2018 als eindredacteur bij <span style={{fontStyle: 'italic'}}>NRC</span>,
                    en redigeer ik teksten voor maatschappelijke organisaties en particuliere ondernemers. <br/><br/>
                    Het is altijd mijn doel om teksten zo vlot en begrijpelijk mogelijk te maken.
                    Als een mes door de boter, dat moet de leeservaring zijn.
                    Het is niet altijd eenvoudig om dat voor elkaar te krijgen.
                    Hoe fijner het is om een tekst te lezen, hoe meer werk erin zit van de schrijver.
                    Als eindredacteur help ik de schrijver om teksten naar een hoger niveau te tillen. <br/><br/>

                    De leesbaarheid vergroot ik onder andere door te schrappen waar nodig, precies te formuleren,
                    en de schrijver aan te moedigen het abstracte concreet te maken.

                    Daarnaast ben ik alert op zwakke elementen in de argumentatie, zorg ik ervoor dat de tekst aansluit
                    bij de beoogde doelgroep, verwijder ik uiteraard taal-en stijlfouten en let ik op alle andere zaken
                    die een tekst (on)aantrekkelijk maken.

                    Dit alles met respect voor de auteur. <br/><br/>
                    Ik redigeer en heb ervaring met het redigeren van:
                    <List bulleted>
                        <List.Item style={{color: 'var(--primary-col)'}}><span style={{color: 'black'}}>Websites</span></List.Item>
                        <List.Item style={{color: 'var(--primary-col)'}}><span style={{color: 'black'}}>Speeches</span></List.Item>
                        <List.Item style={{color: 'var(--primary-col)'}}><span style={{color: 'black'}}>Motivatiebrieven</span></List.Item>
                        <List.Item style={{color: 'var(--primary-col)'}}><span style={{color: 'black'}}>Subsidie-aanvragen</span></List.Item>
                        <List.Item style={{color: 'var(--primary-col)'}}><span style={{color: 'black'}}>Rapporten</span></List.Item>
                        <List.Item style={{color: 'var(--primary-col)'}}><span style={{color: 'black'}}>Journalistieke stukken</span></List.Item>
                        <List.Item style={{color: 'var(--primary-col)'}}><span style={{color: 'black'}}>Non-fictieboeken</span></List.Item>
                    </List>

                    Vragen of interesse? Stuur vooral een <Link to={'mailto:manouk.vanegmond@gmail.com'} className={styles.standardLink}>mail</Link>.
                </p>
            </Rij>
        </Grid>
        <Footer/>
    </ResponsiveContainer>
)

export default Eindredactie
